goog.provide('el8.data.practiceSettings');

goog.require('el8.model.base');
goog.require('el8.service.urls');


el8.data.practiceSettings = (function () {

    var _class = function (spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addIntProperty('scheduleInterval', true);
    _class.addBoolean('invoicingEnabled', true, false);
    _class.addBoolean('deferredBillsEnabled', true, false);
    _class.addBoolean('visitNoteSendBillToPmsEnabled', true, false);
    _class.addBoolean('passportNoticeInVisitSummaries', true, true);
    _class.addBoolean('passportMessagesEnabled', true, false);
    _class.addBoolean('apptRemindersEnabled', true, false);
    _class.addBoolean('schedulerCompactItems', true, false);
    _class.addBoolean('showCancelledApptsEnabled', true, false);
    _class.addBoolean('hccScoringEnabled', true, true);
    _class.addBoolean('staffCdsEnabled', true);
    _class.addBoolean('staffCdsDisplaySupDiag', true);
    _class.addProperty('staffSupportsEnabled', true);
    _class.addIntProperty('patientChartSort', true);
    _class.addBoolean('billCodingDxImportAllLines', true, false);
    _class.addBoolean('bulkResendSentToPmsBills', false);
    _class.addBoolean('billCompletenessCheckEnabled', false);
    _class.addIntProperty('billCompletenessMissingCptDxCodesAlertPreference', true);
    _class.addIntProperty('billCompletenessMissingCptCodesAlertPreference', true);
    _class.addIntProperty('billCompletenessMissingDxCodesAlertPreference', true);
    _class.addIntProperty('billCompletenessMissingServLocAlertPreference', true);

    _class.addBoolean('autoShareIntoPlr', false);
    _class.addBoolean('hasSetAutoShareStatus', false);

    _class.addBoolean('additionalVitalsEnabled', true, false);
    _class.addBoolean('insuranceSettingsAdminOnly', true, false);

    _class.prototype._saveNewValue = function (fieldName, newValue, successCb) {
        var that = this;
        var postDict = {};
        postDict[fieldName] = newValue;

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('practiceSettings', [el8.data.currPractice.getId()]),
            data: JSON.stringify(postDict),
            success: function (data) {
                that.populate(data);
                if (successCb) { successCb(); }
            }
        });
    };

    // This is a practice feature flag with it's own route
    _class.prototype.updateDefaultFaxAttachEnabled = function (isEnabled, successCb) {
        $.el8_ajax({
            url: el8Globals.PRACTICE_PATH + 'default-fax-attach/',
            type: 'POST',
            data: JSON.stringify({ is_on: isEnabled }),
            success: function (data) {
                // Upadate the feature value in globals
                el8Globals.FEATURES.DefaultFaxAttach = data.is_on;
                if (successCb) { successCb(); }
            }
        });
    };

    _class.prototype.updateScheduleInterval = function (interval, successCb) {
        this._saveNewValue('schedule_interval', interval, successCb);
    };

    _class.prototype.updateInvoicingEnabled = function (isEnabled, successCb) {
        this._saveNewValue('invoicing_enabled', isEnabled, successCb);
    };

    _class.prototype.updateDeferredBillsEnabled = function (isEnabled, successCb) {
        this._saveNewValue('deferred_bills_enabled', isEnabled, successCb);
    };

    _class.prototype.updateSchedulerCompactItems = function (isEnabled, successCb) {
        this._saveNewValue('scheduler_compact_items', isEnabled, successCb);
    };

    _class.prototype.updateShowCancelledApptsEnabled = function (isEnabled, successCb) {
        this._saveNewValue('show_cancelled_appts_enabled', isEnabled, successCb);
    };

    _class.prototype.updatePassportNoticeInVisitSummaries = function (isEnabled, successCb) {
        this._saveNewValue('passport_notice_in_visit_summaries', isEnabled, successCb);
    };

    _class.prototype.updateHccScoringEnabled = function (isEnabled, successCb) {
        this._saveNewValue('hccscoring_enabled', isEnabled, successCb);
    };

    _class.prototype.updateStaffCdsEnabled = function (isEnabled, successCb) {
        this._saveNewValue('staff_cds_enabled', isEnabled, successCb);
    };

    _class.prototype.updateStaffCdsDisplaySupDiag = function (isEnabled, successCb) {
        this._saveNewValue('staff_cds_display_sup_diag', isEnabled, successCb);
    };

    _class.prototype.updatePatientChartSort = function (sort, successCb) {
        this._saveNewValue('patient_chart_sort', sort, successCb);
    };

    // maps the integer from getPatientChartSort to a string
    _class.prototype.getPatientChartSortStr = function () {
        var sort = this.getPatientChartSort();
        if (sort === 1) { return 'patient'; }
        else if (sort === 2) { return 'provider'; }
        else { return ''; }
    };

    _class.prototype.updateBillCompletenessCheckEnabled = function (isEnabled, successCb) {
        this._saveNewValue('bill_completeness_check_enabled', isEnabled, successCb);
    }

     _class.prototype.updateBillCompletenessMissingCptDxCodesAlertPreference = function (preference, successCb) {
        this._saveNewValue('bill_completeness_missing_cpt_dx_codes_alert_preference', preference, successCb);
    }

     _class.prototype.updateBillCompletenessMissingCptCodesAlertPreference = function (preference, successCb) {
        this._saveNewValue('bill_completeness_missing_cpt_codes_alert_preference', preference, successCb);
    }

     _class.prototype.updateBillCompletenessMissingDxCodesAlertPreference = function (preference, successCb) {
        this._saveNewValue('bill_completeness_missing_dx_codes_alert_preference', preference, successCb);
    }

     _class.prototype.updateBillCompletenessMissingServLocAlertPreference = function (preference, successCb) {
        this._saveNewValue('bill_completeness_missing_serv_loc_alert_preference', preference, successCb);
    }

    _class.prototype.getConfigurableCodesEnabled = function () {
        var currSet = this.getStaffSupportsEnabled();
        var configurableCDS = _.reject(el8.data.decisionSupports.allAsSoyMaps(), function (ds) {
            return !ds.isConfigurable;  // Remove the ones that are not configurable
        });
        var configurableCodes = configurableCDS.map(function (el) { return el.nqfCode; });
        return _.intersection(currSet, configurableCodes);
    };
    _class.prototype.enableStaffSupport = function (nqfCode, successCb) {
        // takes as arg an array of nqf codes - only send the configurable ones
        var newSet = _.union(this.getConfigurableCodesEnabled(), [nqfCode]);
        this._saveNewValue('staff_supports_enabled', newSet, successCb);
    };
    _class.prototype.disableStaffSupport = function (nqfCode, successCb) {
        // takes as arg an array of nqf codes - only send the configurable ones
        var newSet = _.difference(this.getConfigurableCodesEnabled(), [nqfCode]);
        this._saveNewValue('staff_supports_enabled', newSet, successCb);
    };

    _class.prototype.updateStaffSupports = function (nqfCodes, successCb) {
        this._saveNewValue('staff_supports_enabled', nqfCodes, successCb);
    };

    _class.prototype.isStaffSupportEnabled = function (nqfCode) {
        // takes as arg a single nqf code
        return _.contains(this.getStaffSupportsEnabled(), nqfCode);
    };

    _class.prototype.updatePassportMessagesEnabled = function (isEnabled, successCb) {
        this._saveNewValue('passport_messages_enabled', isEnabled, successCb);
    };

    _class.prototype.updateAutoShareIntoPlr = function (sharing, successCb) {
        this._saveNewValue('auto_share_into_plr', sharing, successCb);
    };

    _class.prototype.updateHasSetAutoShareStatus = function (has_set, successCb) {
        this._saveNewValue('has_set_auto_share_status', has_set, successCb);
    };

    _class.prototype.updateAdditionalVitalsEnabled = function (isEnabled, successCb) {
        this._saveNewValue('additional_vitals_enabled', isEnabled, successCb);
    };

    var that = new _class({});
    that.load = function (async) {
        $.el8_ajax({
            type: 'GET',
            async: async,
            url: el8.service.urls.get('practiceSettings', [el8.data.currPractice.getId()]),
            success: function (data) {
                that.populate(data);
            }
        });
    };

    return that;

})();
